import React, { useState } from 'react'

import BaseModal from '../BaseModal'
import ButtonTransparent from '../ui/ButtonTransparent'
import { validateAddBin } from './validateAddBin'

import './index.css'

const AddNewBinPartModal = (props) => {
  const [ formValues, setFormValues ] = useState({
    bin: '',
    partNumber: props.partnum ? props.partnum : '',
    count: '',
  })
  const [ touched, setTouched ] = useState(false)
  const isSecondary = !!props.partnum

  const validation = validateAddBin({
    ...formValues,
    existingBins: props.existingBins || [],
  })

  const updateFields = (e) => {
    props.removeError()
    setTouched(true)
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value.toUpperCase()
    })
  }

  const submit = (e) => {
    e.preventDefault()
    if (!validation.ok) return
    props.onAdd(formValues, isSecondary)
  }

  const body = (
    <div className="bin-part-modal">
      <h2 className="bin-part-modal__title">{props.type === 'bin' ? 'Add New Bin' : 'Add Part'}</h2>
      <form className="bin-part-modal__form" onSubmit={submit} autoComplete="off">
        <div className="bin-part-modal__form-group">
          <label className="bin-part-modal__form-label" htmlFor="partNumber">Part #</label>
          <input
            className="bin-part-modal__form-input"
            id="partNumber"
            type="text"
            value={formValues.partNumber}
            name="partNumber"
            onChange={updateFields}
            disabled={props.type === 'bin'}
          />
        </div>
        <div className="bin-part-modal__form-group">
          <label
            className="bin-part-modal__form-label"
            htmlFor="bin"
          >
            Bin #
          </label>
          <input
            className="bin-part-modal__form-input"
            id="bin"
            type="text"
            value={formValues.bin}
            name="bin"
            onChange={updateFields}
          />
        </div>
        <div className="bin-part-modal__form-group">
          <label
            className="bin-part-modal__form-label"
            htmlFor="count"
          >
            Count
          </label>
          <input
            className="bin-part-modal__form-input"
            id="count"
            type="text"
            value={formValues.count}
            name="count"
            onChange={updateFields}
          />
        </div>
        <div className="bin-part-modal__form-error">
          {
            props.modalError &&
            <p className="bin-part-modal__error-text">{props.modalError}</p>
          }
          {
            !props.modalError && touched && !validation.ok &&
            <p className="bin-part-modal__error-text">{validation.error}</p>
          }
        </div>
        <div className="bin-part-modal__form-group bin-part-modal__controls">
          <input
            type="submit"
            value="Add"
            className="bin-part-modal__form-submit btn btn--primary"
            disabled={
              !validation.ok ||
              props.disabled ||
              props.modalError
            }
          />
          <ButtonTransparent
            name="Cancel"
            className="job-details__form-submit btn btn--transparent"
            onClick={props.onClose}
          />
        </div>
      </form>
    </div>
  )
  return (
    <BaseModal
      onClose={props.onClose}
      body={body}
    />
  )
}

export default AddNewBinPartModal
